import { canManageAccounts } from "../../utils/accountManagementPermissions"
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import styles from "./accounts.module.css"
import api from "../../services/api"
import Button from "../../components/Form/Button"
import Input from "../../components/Form/Input"
import Select from "../../components/Form/Select"
import Table from "../../components/Table"
import ModalAccount from "../../components/Modal/ModalAccount"
import ModalConfirm from "../../components/Modal/ModalConfirm"
import ModalDelete from "../../components/Modal/ModalDelete"
import ModalTransactions from "../../components/Modal/ModalTransactions"
import { MdExpandLess, MdExpandMore, MdOutlineDeleteOutline, MdOutlineFileDownload, MdUnfoldLess, MdUnfoldMore } from "react-icons/md"
import { TbLock, TbLockOpen } from "react-icons/tb"
import { toast } from "react-toastify"
import { formatDate, maskCurrency, maskDocument } from "../../utils/formatter"
import Loading from './../layouts/Loading/index'
import { useAuth } from "../../contexts/authContext"
import { getPropertyForItemInArrayById } from "../../utils/utils"
import ModalAddPeriodTest from "../../components/Modal/ModalAddPeriodTest"
import { useParams } from "react-router-dom"
import BackgroundSelectFilter from "../../components/BackgroundSelectFilter"
import DatePicker from "../../components/Form/DatePicker"
import ModalAccountHistory from "../../components/Modal/ModalAccountHistory"

const TABLE_BATCH_SIZE = 50

const Accounts = () => {
    const [modalAccount, setModalAccount] = useState(false)
    const [modalTransactions, setModalTransactions] = useState(false)
    const [modalDelete, setModalDelete] = useState(false)
    const [modalBlock, setModalBlock] = useState(false)
    const [modalTest, setModalTest] = useState(false)
    const [modalHistory, setModalHistory] = useState(false)
    const [accounts, setAccounts] = useState([])
    const [modules, setModules] = useState([])
    const [plans, setPlans] = useState([])
    const [partnersAccounts, setPartnersAccounts] = useState([])
    const [account, setAccount] = useState({})
    const [transactions, setTransactions] = useState({})
    const [edit, setEdit] = useState(false)
    const [isNew, setIsNew] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false)
    const [filters, setFilters] = useState({})
    const [tempFilters, setTempFilters] = useState({})
    const [hasSearched, setHasSearched] = useState(false)
    const [accountIdSelected, setAccountIdSelected] = useState()
    const [statusAccountBlock, setStatusAccountBlock] = useState('')
    const [loading, setLoading] = useState(false)
    const [loadMore, setLoadMore] = useState(false)
    const [pagination, setPagination] = useState({ page: 1, limit: TABLE_BATCH_SIZE, total: 0, totalAccounts: 0, hasMore: false })
    const [summary, setSummary] = useState({})
    const [headers, setHeaders] = useState([])
    const [expandedAccounts, setExpandedAccounts] = useState({})
    const [expandAllRows, setExpandAllRows] = useState(false)
    const loadingAccountsRef = useRef(false)
    const accountsRequestRef = useRef(0)

    const { permissions } = useAuth()
    const { account_id } = useParams()
    const canEditAccounts = canManageAccounts(permissions)

    const optionsStatus = [
        { id: 1, value: "Acesso vigente" },
        { id: 0, value: "Sem acesso vigente" },
    ]

    const optionsIsPartner = [
        { id: true, value: "Sim" },
        { id: false, value: "Não" },
    ]

    const optionsSaleStatus = [
        { id: "yes", value: "Sim" },
        { id: "no", value: "Não" },
    ]

    const optionsIntegrationStatus = [
        { id: "yes", value: "Com integração ativa" },
        { id: "no", value: "Sem integração ativa" },
    ]

    const optionsIntegrations = [
        { id: "meta_forms", value: "Meta Leadgen Ads" },
        { id: "whatsapp", value: "WhatsApp" },
        { id: "whatsapp_api", value: "WhatsApp API" },
        { id: "messenger", value: "Messenger" },
        { id: "direct", value: "Instagram Direct" },
        { id: "google", value: "Google" },
        { id: "conversions", value: "Conversões" },
        { id: "api_forms", value: "Formulários API" },
    ]

    const optionsAttention = [
        { id: "no_sale", value: "Sem venda" },
        { id: "no_recent_sale", value: "Sem venda nos últimos 30 dias" },
        { id: "no_integration", value: "Sem integração" },
        { id: "no_recent_access", value: "Sem acesso nas últimas 24h" },
        { id: "no_recent_meta", value: "Sem Meta Leadgen Ads nas últimas 24h" },
        { id: "pending_meta_config", value: "Meta Leadgen Ads pendente" },
        { id: "no_recent_form", value: "Sem formulário API nas últimas 24h" },
        { id: "pending_api_form_config", value: "Formulários API pendentes" },
    ]

    useEffect(() => {
        getAllModules()
        getAllPlans()
    }, [])

    useEffect(() => {
        if (hasSearched) {
            getAllAccounts({ page: 1, reset: true })
        }
    }, [filters, hasSearched])

    useEffect(() => {
        setIsAdmin(permissions?.is_admin > 0 || permissions?.accessByAdmin)
    }, [permissions?.is_admin, permissions?.accessByAdmin])

    useEffect(() => {
        setHeaders(isAdmin ?
            [
                "#",
                "Documento",
                "Razão Social",
                "Nome da Conta",
                "Cadastro",
                "Primeiro pagamento",
                "Status",
                "Data de Expiração",
                "É Conta Parceira?",
                "Conta Responsável",
                "Plano",
                "Responsável",
                "Atenção",
                "Vendas",
                "Integrações ativas",
                "Últ. Meta Leadgen Ads",
                "Últ. Formulário",
                "Últ. Acesso",
                "Consumo",
                "Saldo ligações",
                "Créditos IA",
                ""
            ] : [
                "#",
                "Documento",
                "Razão Social",
                "Nome da Conta",
                "Cadastro",
                "Primeiro pagamento",
                "Status",
                "Data de Expiração",
                "Plano",
                "Responsável",
                "Atenção",
                "Vendas",
                "Integrações ativas",
                "Últ. Meta Leadgen Ads",
                "Últ. Formulário",
                "Últ. Acesso",
                "Consumo",
                "Saldo VoIP",
                "Saldo Chat",
                ""
            ]
        )
        if (isAdmin) {
            getAllPartners()
        }
    }, [isAdmin])

    const getAccountsParams = ({ page = 1, limit = TABLE_BATCH_SIZE } = {}) => ({
        page,
        limit,
        partners: filters?.partners?.join?.(","),
        is_partner: filters?.is_partner?.join?.(","),
        is_active: filters?.is_active?.join?.(","),
        plans: filters?.plans?.join?.(","),
        sale_status: filters?.sale_status?.join?.(","),
        integration_status: filters?.integration_status?.join?.(","),
        integrations: filters?.integrations?.join?.(","),
        attention: filters?.attention?.join?.(","),
        registration_date_start: filters?.registration_date_start || undefined,
        registration_date_end: filters?.registration_date_end || undefined,
        first_payment_date_start: filters?.first_payment_date_start || undefined,
        first_payment_date_end: filters?.first_payment_date_end || undefined,
        textSearch: filters?.textSearch || undefined,
    })

    const getAccountsExportParams = () => {
        const params = getAccountsParams({})
        delete params.page
        delete params.limit
        return { ...params, export_xlsx: true }
    }

    const getAllAccounts = async ({ page = 1, reset = false, limit = TABLE_BATCH_SIZE } = {}) => {
        let requestId
        try {
            if (!reset && loadingAccountsRef.current) {
                return
            }

            requestId = accountsRequestRef.current + 1
            accountsRequestRef.current = requestId
            loadingAccountsRef.current = true

            if (reset) {
                setLoading(true)
                setLoadMore(false)
            } else {
                setLoadMore(true)
            }

            const response = await api.get("/accounts/all", { params: getAccountsParams({ page, limit }) })
                const listAccounts = response.data?.data || []

                if (requestId === accountsRequestRef.current) {
                    setAccounts(previousValue => reset ? listAccounts : [...previousValue, ...listAccounts])
                    setSummary(previousValue => response.data?.summary || previousValue)
                    const newPagination = response.data?.pagination || {}
                setPagination(previousValue => ({
                    page: newPagination.page || page,
                    limit: newPagination.limit || limit,
                    total: newPagination.total ?? previousValue.total ?? listAccounts.length,
                    totalAccounts: newPagination.totalAccounts ?? previousValue.totalAccounts ?? listAccounts.length,
                    hasMore: newPagination.hasMore || false,
                }))
            }
        } catch (err) {
            toast.error(err?.response?.data?.message)
        } finally {
            if (requestId === accountsRequestRef.current) {
                setLoading(false)
                setLoadMore(false)
                loadingAccountsRef.current = false
            }
        }
    }

    const exportAccounts = async () => {
        try {
            setLoading(true)
            const response = await api.get("/accounts/all", { params: getAccountsExportParams(), responseType: "blob" })
            const blob = new Blob([response.data], { type: response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            const url = URL.createObjectURL(blob)
            const link = document.createElement("a")
            link.href = url
            link.download = `gerenciar-contas-${new Date().toISOString().replace(/[:.]/g, "-")}.xlsx`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url)
        } catch (err) {
            toast.error(err?.response?.data?.message || "Não foi possível exportar as contas.")
        } finally {
            setLoading(false)
        }
    }

    const getAccountById = (id) => {
        return new Promise(resolve => {
            setLoading(true)
            api.get(`/accounts/${id}`).then(response => {
                const account = response.data?.data
                if (account) {
                    account.account_id = account._id
                }
                if (account.modules) {
                    account.modules = account.modules?.map(module => { return module.module_id })
                }
                setAccount(account)
                resolve(1)
            }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
        })
    }

    const getTransactionsAccountById = (id) => {
        return new Promise(resolve => {
            setLoading(true)
            api.get(`/accounts/${id}/transactions`).then(response => {
                const transactions = response.data?.data
                setTransactions(transactions)
                resolve(1)
            }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
        })
    }

    const getAllModules = () => {
        api.get(`/modules`).then(response => {
            const modules = response.data?.data || []
            setModules(modules?.map(module => ({
                id: module._id,
                value: module.name,
                description: module.description,
                action: module.action,
            })))
        }).catch(err => toast.error(err?.response?.data?.message))
    }

    const getAllPartners = () => {
        api.get(`/accounts/allPartners`).then(response => {
            const partners = response.data?.data || []
            setPartnersAccounts(partners?.map(partner => { return { id: partner._id, value: partner.name } }))
        }).catch(err => toast.error(err?.response?.data?.message))
    }

    const getAllPlans = () => {
        api.get(`/plans`, { headers: { "x-api-key": account_id } }).then(response => {
            const plans = response.data?.data || []
            setPlans(plans)
        }).catch(err => toast.error(err?.response?.data?.message))
    }

    const openModalAccount = async (isNew = false, edit = false, id = undefined) => {
        setEdit(edit)
        setIsNew(isNew)
        setAccount({})
        if (!isNew && id) {
            await getAccountById(id)
        }
        setModalAccount(true)
    }

    const closeModalAccount = () => {
        setModalAccount(false)
    }

    const openModalTransactions = async (id) => {
        await getTransactionsAccountById(id)
        setAccountIdSelected(id)
        setModalTransactions(true)
    }

    const closeModalTransactions = () => {
        setModalTransactions(false)
    }

    const closeModalDelete = () => {
        setModalDelete(false)
    }

    const openModalBlock = async (id) => {
        setAccountIdSelected(id)
        setStatusAccountBlock(getStatusAccountById(id))
        setModalBlock(true)
    }

    const getStatusAccountById = (id) => {
        let status = false
        accounts.forEach(account => {
            if (account._id === id) {
                status = account.is_active
            }
        })
        return status
    }

    const getExpiresAtById = (id) => {
        let expires_in = ''
        accounts.forEach(account => {
            if (account._id === id) {
                expires_in = account.expires_in
            }
        })
        return expires_in
    }

    const closeModalBlock = () => {
        setModalBlock(false)
    }

    const openModalAddTest = async (id) => {
        setAccountIdSelected(id)
        setModalTest(true)
    }

    const closeModalTest = () => {
        setModalTest(false)
    }

    const openModalHistory = (id) => {
        const selectedAccount = accounts.find(item => item._id === id)
        setAccountIdSelected(id)
        setAccount({ name: selectedAccount?.name || "Conta" })
        setModalHistory(true)
    }

    const closeModalHistory = () => {
        setModalHistory(false)
    }

    const handleSaveAccount = (e, isNew, account) => {
        e.preventDefault()
        if (isNew) {
            handleSaveNewAccount(account)
        } else {
            handleUpdateAccount(account)
        }
    }

    const handleSaveNewAccount = (account) => {
        setLoading(true)
        api.post("/accounts", account).then(response => {
            const newAccount = response.data?.data
            if (newAccount) {
                setAccounts(previousValue => {
                    const newValue = [...previousValue]
                    newValue.push(newAccount)

                    return newValue
                })
            }
            toast.success(response.data.message)
            closeModalAccount()
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const isAccountExpanded = useCallback((id) => expandAllRows ? expandedAccounts[id] !== false : !!expandedAccounts[id], [expandAllRows, expandedAccounts])

    const toggleAccountDetails = (e, id) => {
        e.stopPropagation()
        setExpandedAccounts(previousValue => ({ ...previousValue, [id]: !isAccountExpanded(id) }))
    }

    const toggleAllRows = () => {
        setExpandedAccounts({})
        setExpandAllRows(previousValue => !previousValue)
    }

    const getDataNewAccount = (newAccount) => {
        const health = newAccount?.partner_health || {}
        const accountPlan = plans.find(plan => plan?._id === newAccount?.plan_id)
        const renderBadge = (text, type = "neutral") => <span className={`${styles.badge} ${styles[type]}`} title={text}>{text}</span>
        const expanded = isAccountExpanded(newAccount._id)
        const renderList = (items = [], collapsedLimit = 1) => {
            const visibleItems = items.slice(0, expanded ? 6 : collapsedLimit)
            const hiddenItems = items.slice(visibleItems.length)
            return visibleItems.length > 0 ? (
                <div className={`${styles.badgeList} ${expanded ? styles.expandedList : styles.compactList}`} title={items.join(", ")}>
                    {visibleItems.map(item => <React.Fragment key={item}>{renderBadge(item, "neutral")}</React.Fragment>)}
                    {hiddenItems.length > 0 && renderBadge(expanded ? `+${hiddenItems.length}: ${hiddenItems.join(", ")}` : `+${hiddenItems.length}`, "neutral")}
                </div>
            ) : "-"
        }
        const renderUsage = (usage = {}) => {
            const getUsageText = (label, item = {}) => {
                const limitText = item.unlimited || !item.limit ? "sem limite" : item.limit
                const percentText = item.percent !== null && item.percent !== undefined ? ` · ${item.percent}%` : ""
                return `${label}: ${item.used || 0}/${limitText}${percentText}`
            }

            return (
                <div className={`${styles.badgeList} ${expanded ? styles.expandedList : styles.compactList}`}>
                    {renderBadge(getUsageText("Usuários", usage.users), usage?.users?.level || "neutral")}
                    {expanded && renderBadge(getUsageText("Leads", usage.leads), usage?.leads?.level || "neutral")}
                    {expanded && renderBadge(getUsageText("Caixas", usage.inboxes), usage?.inboxes?.level || "neutral")}
                </div>
            )
        }
        const renderAttention = () => (
            <div className={styles.detailsCell}>
                <button className={styles.expandRowButton} onClick={(e) => toggleAccountDetails(e, newAccount._id)} title={expanded ? "Recolher informações" : "Expandir informações"}>
                    {expanded ? <MdExpandLess /> : <MdExpandMore />}
                </button>
                {attentionFlags.length > 0 ? renderList(attentionFlags, 1) : renderBadge("Em dia", "success")}
            </div>
        )
        const attentionFlags = health?.attention_flags || []
        const value = [
            newAccount?.is_foreigner ? newAccount.document : maskDocument(newAccount.document),
            newAccount?.business_name?.substring(0, 30),
            newAccount?.name?.substring(0, 30),
            formatDate(newAccount?.created_at, "DD/MM/YYYY") || "-",
            formatDate(newAccount?.first_payment_at, "DD/MM/YYYY") || "-",
            newAccount?.access_active ? "Vigente" : "Sem acesso",
            formatDate(newAccount?.expires_in, "DD/MM/YYYY") || "-",
        ]
        const actions = [
            {
                label: "Acessar a Conta",
                onClick: redirectToAccount
            }
        ]
        if (canEditAccounts) {
            actions.push({
                label: "Editar",
                onClick: (id) => openModalAccount(false, true, id)
            })
            if (accountPlan?.payment_by_partner) {
                actions.push({
                    label: newAccount?.is_active ? "Bloquear a Conta" : "Ativar a Conta",
                    onClick: openModalBlock
                })
            }
        }
        if (isAdmin) {
            value.push(
                newAccount?.is_partner ? "Sim" : "Não",
                getPropertyForItemInArrayById(newAccount?.partner_of, partnersAccounts, "id", "value")?.substring(0, 30) || "-"
            )
            if (canEditAccounts) {
                actions.push(
                    {
                        label: "Liberar período de teste",
                        onClick: openModalAddTest
                    },
                    {
                        label: "Excluir",
                        onClick: handleDeleteAccount
                    }
                )
            }
        }
        if (canEditAccounts) {
            actions.push({
                label: "Visualizar Financeiro",
                onClick: openModalTransactions
            })
        }
        if (isAdmin) {
            actions.push({
                label: "Histórico de alterações",
                onClick: openModalHistory
            })
        }
        value.push(
            accountPlan?.name || "-",
            newAccount?.owner_name?.substring(0, 30) || "-",
            renderAttention(),
            health?.has_sale ? renderBadge("Sim", "success") : renderBadge("Não", "danger"),
            health?.integration_labels?.length > 0 ? renderList(health.integration_labels, 2) : renderBadge("Nenhuma", "danger"),
            formatDate(health?.last_meta_lead_at, "DD/MM/YYYY") || "-",
            formatDate(health?.last_form_send_at, "DD/MM/YYYY") || "-",
            formatDate(health?.last_access, "DD/MM/YYYY HH:mm") || "-",
            renderUsage(health?.usage),
            maskCurrency(parseFloat(newAccount?.credits_voip || 0).toFixed(2)),
            `${Number(newAccount?.credits_chat || 0).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} créditos`,
        )
        return {
            id: newAccount._id,
            name: newAccount.name,
            partner_of: isAdmin ? newAccount?.partner_of : undefined,
            is_partner: isAdmin ? newAccount?.is_partner : undefined,
            plan_id: newAccount?.plan_id,
            is_active: newAccount?.is_active,
            value,
            actions
        }
    }

    const handleUpdateAccount = (account) => {
        setLoading(true)
        api.patch(`/accounts/${account._id}`, account).then(response => {
            setAccounts(previousValue => {
                return previousValue?.map(lastAccount => {
                    if (lastAccount._id === account._id) {
                        lastAccount.document = account?.company?.document ? account.company.document : lastAccount.document
                        lastAccount.business_name = account?.company?.business_name ? account.company.business_name : lastAccount.business_name
                        lastAccount.is_partner = account?.is_partner ? account.is_partner : lastAccount?.is_partner
                        lastAccount.partner_of = account?.partner_of ? account.partner_of : lastAccount?.partner_of
                        lastAccount.plan_id = account?.plan_details?.plan_id ? account.plan_details.plan_id : lastAccount?.plan_details?.plan_id
                        const selectedOwner = account?.owner_candidates?.find(user => user?._id?.toString() === account?.owner?.toString())
                        lastAccount.owner_name = selectedOwner?.name || selectedOwner?.email || lastAccount.owner_name
                    }
                    return lastAccount
                })
            })
            toast.success(response.data.message)
            closeModalAccount()
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const handleDeleteAccount = (id) => {
        setAccountIdSelected(id)
        setModalDelete(true)
    }

    const handleToogleIsActiveAccount = () => {
        setLoading(true)
        api.patch(`/accounts/${accountIdSelected}/toogle-status`).then(response => {
            setAccounts(previousValue => {
                return previousValue?.map(lastAccount => {
                    const newValue = { ...lastAccount }
                    if (newValue._id === accountIdSelected) {
                        newValue.is_active = !lastAccount.is_active
                    }
                    return newValue
                })
            })
            closeModalBlock()
            toast.success(response?.data?.message)
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const handleAddPeriodTestByAccount = (expires_at) => {
        setLoading(true)
        api.patch(`/accounts/${accountIdSelected}/add-test-period`, { expires_at }).then(response => {
            setAccounts(previousValue => {
                return previousValue?.map(lastAccount => {
                    const newValue = { ...lastAccount }
                    if (newValue._id === accountIdSelected) {
                        newValue.expires_in = expires_at
                    }
                    return newValue
                })
            })
            closeModalTest()
            toast.success(response?.data?.message)
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const deleteAccount = (id) => {
        setLoading(true)
        api.delete(`/accounts/${id}`).then(response => {
            setAccounts(previousValue => {
                return previousValue?.filter(lastAccount => lastAccount._id !== id)
            })
            toast.success(response.data.message)
            closeModalDelete()
        }).catch(err => toast.error(err?.response?.data?.message)).finally(() => setLoading(false))
    }

    const redirectToAccount = (id) => {
        const link = document.createElement("a")
        link.href = `/${id}`
        link.setAttribute("target", "_blank")
        link.setAttribute("rel", "noopener noreferrer")
        link.click()
    }

    const filteredValues = useMemo(() => accounts?.map((account) => getDataNewAccount(account)), [accounts, plans, partnersAccounts, isAdmin, isAccountExpanded, canEditAccounts])

    const handleChangeValue = (name, value) => {
        setTempFilters(previousValue => { return { ...previousValue, [name]: value } })
    }

    const handleChangeDatePeriod = (prefix, dateStart, dateEnd) => {
        setTempFilters(previousValue => ({
            ...previousValue,
            [`${prefix}_date_start`]: dateStart || "",
            [`${prefix}_date_end`]: dateEnd || "",
        }))
    }

    const applyFilters = () => {
        setHasSearched(true)
        setFilters({ ...tempFilters })
    }

    const handleSearchKeyDown = (e) => {
        if (e.key === "Enter") {
            applyFilters()
        }
    }

    const loadMoreRows = useCallback(() => {
        if (pagination.hasMore && !loadingAccountsRef.current) {
            getAllAccounts({ page: pagination.page + 1 })
        }
    }, [pagination])

    return (
        <div className={styles.container}>
            <section className={styles.summaryGrid}>
                <div className={`${styles.summaryCard} ${summary.withoutSale > 0 ? styles.warningCard : ""}`}>
                    <small>Sem venda registrada</small>
                    <strong>{summary.withoutSale || 0}</strong>
                    <span>{summary.withoutRecentSale || 0} sem venda nos últimos 30 dias</span>
                </div>
                <div className={`${styles.summaryCard} ${summary.withoutIntegration > 0 ? styles.dangerCard : ""}`}>
                    <small>Sem integração ativa</small>
                    <strong>{summary.withoutIntegration || 0}</strong>
                    <span>{summary.withIntegration || 0} com alguma integração ativa</span>
                </div>
                <div className={`${styles.summaryCard} ${summary.withoutRecentAccess > 0 ? styles.warningCard : ""}`}>
                    <small>Sem acesso nas últimas 24h</small>
                    <strong>{summary.withoutRecentAccess || 0}</strong>
                    <span>Acesso de qualquer usuário da conta</span>
                </div>
                <div className={`${styles.summaryCard} ${summary.withoutRecentMeta > 0 || summary.withoutRecentForm > 0 ? styles.warningCard : ""}`}>
                    <small>Sem cadastros nas últimas 24h</small>
                    <strong>{summary.withoutRecentRegistration ?? ((summary.withoutRecentMeta || 0) + (summary.withoutRecentForm || 0))}</strong>
                    <span>Meta Leadgen Ads: {summary.withoutRecentMeta || 0} · Pend. Meta: {summary.withPendingMeta || 0} · API: {summary.withoutRecentForm || 0} · Pend. API: {summary.withPendingForm || 0}</span>
                </div>
            </section>
            <div className={styles.actions}>
                <div className={styles.toolbar}>
                    <div className={styles.primaryActions}>
                        {canEditAccounts && <Button variant="primary" onClick={() => openModalAccount(true, true)}>Adicionar Conta</Button>}
                    </div>
                    <div className={styles.secondaryActions}>
                        {canEditAccounts && <button className={styles.exportButton} onClick={exportAccounts} type="button" title="Exportar contas filtradas para Excel">
                            <MdOutlineFileDownload />
                            <span>Exportar Excel</span>
                        </button>}
                        <button className={styles.expandAllButton} onClick={toggleAllRows} type="button" title={expandAllRows ? "Recolher todas as linhas" : "Expandir todas as linhas"}>
                            {expandAllRows ? <MdUnfoldLess /> : <MdUnfoldMore />}
                            <span>{expandAllRows ? "Recolher todos" : "Expandir todos"}</span>
                        </button>
                    </div>
                </div>
                <div className={styles.filters}>
                    {isAdmin &&
                        <>
                            <Select multiple={true} name="Parceiros" placeholder="Buscar..." options={partnersAccounts} onChange={(value) => handleChangeValue("partners", value)} selected={tempFilters?.partners || []} />
                            <Select multiple={true} name="É Conta Parceira" placeholder="Buscar..." options={optionsIsPartner} onChange={(value) => handleChangeValue("is_partner", value)} selected={tempFilters?.is_partner || []} />
                        </>
                    }
                    <Select multiple={true} name="Status" placeholder="Buscar..." options={optionsStatus} onChange={(value) => handleChangeValue("is_active", value)} selected={tempFilters?.is_active || []} />
                    <Select multiple={true} name="Planos" placeholder="Buscar..." options={plans?.map(plan => { return { id: plan?._id, value: plan?.name } }) || []} onChange={(value) => handleChangeValue("plans", value)} selected={tempFilters?.plans || []} />
                    <Select multiple={true} name="Vendas" placeholder="Buscar..." options={optionsSaleStatus} onChange={(value) => handleChangeValue("sale_status", value)} selected={tempFilters?.sale_status || []} />
                    <Select multiple={true} name="Integração" placeholder="Buscar..." options={optionsIntegrationStatus} onChange={(value) => handleChangeValue("integration_status", value)} selected={tempFilters?.integration_status || []} />
                    <Select multiple={true} name="Quais integrações" placeholder="Buscar..." options={optionsIntegrations} onChange={(value) => handleChangeValue("integrations", value)} selected={tempFilters?.integrations || []} />
                    <Select multiple={true} name="Precisa de atenção" placeholder="Buscar..." options={optionsAttention} onChange={(value) => handleChangeValue("attention", value)} selected={tempFilters?.attention || []} />
                    <DatePicker multiple={true} name="Data de cadastro" dateStart={tempFilters?.registration_date_start || ""} dateEnd={tempFilters?.registration_date_end || ""} onChange={(dateStart, dateEnd) => handleChangeDatePeriod("registration", dateStart, dateEnd)} />
                    <DatePicker multiple={true} name="Primeiro pagamento" dateStart={tempFilters?.first_payment_date_start || ""} dateEnd={tempFilters?.first_payment_date_end || ""} onChange={(dateStart, dateEnd) => handleChangeDatePeriod("first_payment", dateStart, dateEnd)} />
                    <Input type="search" placeholder="Buscar..." value={tempFilters?.textSearch || ''} onChange={(e) => handleChangeValue("textSearch", e.target.value)} onKeyDown={handleSearchKeyDown} />
                    <Button variant="secondary" onClick={applyFilters}>Filtrar</Button>
                </div>
            </div>
            <div className={styles.resultsArea}>
                {hasSearched ?
                    <Table
                        headers={headers}
                        values={filteredValues}
                        className={`${styles.accountsTable} ${filteredValues.length >= 10 ? styles.accountsTableWithTenRows : ""}`}
                        messageNotRegisters="Nenhuma conta encontrada"
                        onClick={(id) => openModalAccount(false, false, id)}
                        onScroll={loadMoreRows}
                        loadMore={loadMore}
                        showIndex={true}
                        showCount={true}
                        count={`${pagination.total || 0}/${pagination.totalAccounts || 0}`}
                    />
                    :
                    <BackgroundSelectFilter
                        title="Filtre antes de carregar"
                        text="Escolha os filtros desejados para buscar somente as contas que você precisa visualizar."
                    />
                }
            </div>
            {modalAccount &&
                <ModalAccount
                    closeModal={closeModalAccount}
                    onSubmit={handleSaveAccount}
                    isNew={isNew}
                    editable={edit}
                    setEdit={setEdit}
                    value={account}
                    modules={modules}
                    plans={plans}
                    partnersAccounts={partnersAccounts}
                    canEdit={canEditAccounts}
                    optionsStatus={optionsStatus}
                />
            }
            {modalTransactions &&
                <ModalTransactions
                    account_id={accountIdSelected}
                    closeModal={closeModalTransactions}
                    value={transactions}
                />
            }
            {modalHistory &&
                <ModalAccountHistory
                    accountId={accountIdSelected}
                    accountName={account?.name}
                    closeModal={closeModalHistory}
                />
            }
            {modalDelete &&
                <ModalDelete
                    closeModal={closeModalDelete}
                    onSubmit={deleteAccount}
                    icon={<MdOutlineDeleteOutline />}
                    title="Exclusão de conta"
                    description="Deseja realmente excluir a conta?"
                    id={accountIdSelected}
                />
            }
            {modalBlock &&
                <ModalConfirm
                    closeModal={closeModalBlock}
                    onSubmit={handleToogleIsActiveAccount}
                    icon={statusAccountBlock ? <TbLock /> : <TbLockOpen />}
                    title={statusAccountBlock ? "Bloqueio de Conta" : "Ativação de Conta"}
                    description={statusAccountBlock ? "Deseja realmente bloquear a conta?" : "Deseja realmente ativar a conta?"}
                    text={statusAccountBlock ? "Status: Ativa → Bloqueada. Os recursos ficarão inacessíveis; apenas os relatórios autorizados permanecerão disponíveis." : "Status: Bloqueada → Ativa. Os recursos serão restabelecidos e os usuários ativos poderão acessar a conta."}
                />
            }
            {modalTest &&
                <ModalAddPeriodTest
                    closeModal={closeModalTest}
                    onSubmit={handleAddPeriodTestByAccount}
                    expires_at={getExpiresAtById(accountIdSelected)}
                />
            }
            {loading && <Loading fullPage={true} />}
        </div>
    )
}

export default Accounts
